module.exports = __webpack_public_path__ + "assets/img/white-customer-3.2ef8b3cc.png";